export const mediaFiltersSelector = state => state.mediaFilters.get('mediaFilters');
export const mediaFilterSelector = state => state.mediaFilters.get('mediaFilter');
export const mediaFiltersIsLoadingSelector = state => state.mediaFilters.get('isLoading');
